module.exports = __webpack_public_path__ + "static/media/edit.a5e2267c.svg";